module.exports = __webpack_public_path__ + "static/media/12.26271034.jpg";